import { render, staticRenderFns } from "./NsTopnavSection.vue?vue&type=template&id=0d787487&scoped=true&"
import script from "./NsTopnavSection.vue?vue&type=script&lang=js&"
export * from "./NsTopnavSection.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavSection.vue?vue&type=style&index=0&id=0d787487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d787487",
  null
  
)

export default component.exports